import { styled } from '@lichtblick/styled';
import { BorderRadius, Colors, Spacing } from '@lichtblick/theme';

export const DatePickerButton = styled.div<{ $hasError?: boolean }>`
  align-items: center;
  background-color: ${Colors.white};
  border: 1px solid ${({ $hasError }) => ($hasError ? Colors.red[100] : Colors.blue[20])};
  border-radius: ${BorderRadius.Xs};
  cursor: pointer;
  display: flex;
  gap: ${Spacing.Xxs};
  height: ${Spacing.L};
  justify-content: space-between;
  padding: 0 ${Spacing.Xs};
  width: fit-content;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: ${Spacing.Xxs};
  justify-content: flex-end;
  padding: 0 1rem;
`;

export const TimePickerContainer = styled.div<{ $hasError?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;

  label {
    color: #333;
    font-size: 14px;
    margin-bottom: 4px;
  }

  .react-time-picker {
    width: 100%;
    .react-time-picker__wrapper {
      border: 1px solid ${({ $hasError }) => ($hasError ? Colors.red[100] : '#ccc')};
      border-radius: 4px;
      font-size: 16px;
      padding: 4px 8px;
    }
  }
`;

export const FieldWithErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.Xxs};
`;
